import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as actions from '../../../store/actions';
import { withRouter } from 'react-router';
import Wrp from "../../../hoc/Wrp/Wrp";
import { getWindowObjectUsingWindowName } from '../../../Utils/UserFunctions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import { callPOST, callGET, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import {findFieldWithFilterByName,getSelectedValueBasedOnField} from '../../../Utils/CommonFunctions';
import TableRecord from "../../../Components/UI/TableRecord";
import Icons from '../../../Components/Icons/Icons';
import CreateNew from './CreateNew';

class ChargeDetailsContainer extends Component {
	state = {
		createChargeModel : false,
		chargeList : [],
		charge_formfields : {
			id : null,
			name : '',
			charge_code : '',
			desc : ''
		},
		tableRecords:{
	      tableHead:[
	      	{
              name:"Action",
              type:"Actions",
              href:"",
              isShow:true,
              clickHandler:"",
              attributes:{
                style:{width: "75px"}
              }
            },
	        {
	          name:"Name",
	          type:"Setting",
	          clickHandler:"",
	          isShow:true,
	          attributes:{ }
	        },
	        {
	          name:"Charge Code",
	          type:"Text",
	          isShow:true,
	        },
	        {
              name:"Create By",
              type:"UserCard",
              isShow:true,
              clickHandler:"",
            },
            {
              name:"Last Edited",
              type:"UserCard",
              isShow:true,
              clickHandler:"",
            },
	      ],
	      tableData:[], 
	      pagination:{
	        page:0,
	        orderBy:'name',
	        perPage:10,
	        direction:'DESC',
	        totalRecords:0,
	        search:''
	      }
	    }
	}

	componentWillMount() {
		this.chargeList(this.state.tableRecords.pagination);
	}

	chargeList = (pagination) => {
		this.props.Loader();
	    const page = pagination.page; 
	    const orderBy = pagination.orderBy; 
	    const perPage = pagination.perPage; 
	    const direction = pagination.direction; 
	    const search = pagination.search;
	    this.setState({
	      tableRecords:{
	        ...this.state.tableRecords,
	        pagination:pagination
	      }
	    });
	    const url = "charges/list";
	    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
	    callGET(url+queryString)
	    .then(response => {
	      // console.log(response);
	      this.props.Loader();
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
	        if(responseData.data!==null){
	          let updateTableData = responseData.data.pageable_list.content.map((item,index)=>{
	              return {
	                className:'icon_hover cursor-pointer',
	                rowId:item.id,
	                data:{
	                	actions:[
	                			{
				                  clickHandler:this.editHandler.bind(this,item),
				                  attributes:{
				                    className:"p-1"
			                  	  },
				                  //iconClass:"fas fa-pencil-alt third_dark_color",
				                  svgIcon:'Edit',
				                  name:""
			                  },
			                  {
			                    attributes:{
			                      className:"p-1"
			                    },
			                    svgIcon:"Delete",
			                    // iconClass:"fas fa-trash-alt primary_color",
			                    clickHandler:this.deleteHandler.bind(this,item.id),
			                    name:""
			                  }			                  
			              ],
		                name: {
		                    value: item.name,
		                    clickHandler:this.editHandler.bind(this,item),
		                    param:{
		                      data:{...item},
		                    },
		                    attributes:{
		                      id: item.id
		                      // is_editable: item.is_editable.toString(),
		                    },
		                    setting:{}
	                  	},	
		                charge_code:item.charge_code,
		                create_by:{
		                  username:item.created_by,
		                  time:item.created_at,
		                  img:'/assets/img/profile2.jpg'
		                },
		                last_edited:{
		                  username:item.updated_by,
		                  time:item.updated_at,
		                  img:'/assets/img/profile2.jpg'
		                },
	              }
	            }
	          });
	          const totalRecords = responseData.data.total_elements;
	          
	          this.setState({status:200,tableRecords:{
	              tableData:{data:updateTableData,status:200},
	              tableHead:this.state.tableRecords.tableHead ,
	              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
	          }});
	          // console.log(this.state.tableRecords);
	      }else{
	          const totalRecords = 0;//response.data.totalElements;
	          this.setState({status:200,tableRecords:{
	              tableData:[],
	              tableHead:this.state.tableRecords.tableHead ,
	              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
	          }});    
	      }
	    }else{
	        // this.props.Loader();
	        this.props.failMessage(responseData.message);   
	        const totalRecords = 0;//response.data.totalElements;
	          this.setState({status:200,tableRecords:{
	              tableData:[],
	              tableHead:this.state.tableRecords.tableHead ,
	              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
	          }});    
	    }
	    })
	    .catch(err => {
	      this.props.Loader();
	        console.log("Connction Error============",err);
	    });
  	}

	createChargeToggle = () => {
		const updateState = {...this.state}
		if(updateState.createChargeModel === true) {
			this.clearForms();
		}else {
			updateState.createChargeModel = !updateState.createChargeModel;
			this.setState(updateState);
		}
	}

	createChargeChangeHandler = (e) => {
		const {name,value} = e.target;
		// console.log(name,value,e.target.checked);
		const updateState = {...this.state}
		updateState['charge_formfields'][name] = value;
		this.setState(updateState);
	}

	/*createTaxFilterOnChange = (e) => {
		console.log(e);
		let datevalue = '';
		let dateSysvalue = '';
		let value = [];
		if (typeof e.format === "function") {
			datevalue = e.format('yyyy-MM-DD HH:mm:ss'); 
		}
		console.log(datevalue);
		const updateState = {...this.state}
		updateState['tax_formfields']['valid_from_date'] = datevalue;
		this.setState(updateState);
	}*/

	saveChargeDetails = () => {
		this.props.Loader();
		const chargeFields = this.state.charge_formfields;
		let body = {};
		if(chargeFields.id) {
			body = {
				id: chargeFields.id,
				name: chargeFields.name,
				charge_code: chargeFields.charge_code
			}
		}else {
			body = {
				name: chargeFields.name,
				charge_code: chargeFields.charge_code
			}
		}
		console.log(JSON.stringify(body));

		callPOST("charges/save",body)
	      .then(response => {
	        this.props.Loader();
	        console.log(response);
	        const responseData = response.data;
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	          this.props.succMessage(responseData.message);
	          this.createChargeToggle();
	          this.chargeList(this.state.tableRecords.pagination);
	        }else {
	          this.props.failMessage(responseData.message);
	        }
	      })
	      .catch(err => {
	        this.props.Loader();
	        this.props.failMessage("Error occured");
	        console.log(err);
	      })
	}

	deleteHandler = (ide) => {
		console.log("ide",ide);
		this.props.Loader();
		// let isDelete = window.confirm("are you sure you want to delete this data?");
		// if(isDelete) {
			callDELETE("charges/"+ide)
			.then(response => {
				this.props.Loader();
		        console.log(response);
		        const responseData = response.data;
		        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
		          this.props.succMessage(responseData.message);
		          this.chargeList(this.state.tableRecords.pagination);
		        }else {
		          this.props.failMessage(responseData.message);
		        }
			})
			.catch(err => {
		        this.props.Loader();
		        this.props.failMessage("Error occured");
		        console.log(err);
	      	})
		// }
	}

	editHandler = (data) => {
		console.log(data);
		const updateState = {...this.state}
		updateState['charge_formfields']['id'] = data.id;
		updateState['charge_formfields']['name'] = data.name;
		updateState['charge_formfields']['charge_code'] = data.charge_code;
		updateState['createChargeModel'] = true;
		this.setState(updateState);
	}

	clearForms = () => {
		const updateState = {...this.state};
		updateState['charge_formfields']['id'] = null;
		updateState['charge_formfields']['name'] = '';
		updateState['charge_formfields']['charge_code'] = '';
		updateState['createChargeModel'] = false;
		this.setState(updateState);
	}

	render () {
      const breadCrumbs =  {
          backHistory : [{
          href : "/settings",
          name:"Settings"
          }],
          pageTitle:"Charge",
          buttonList:[{
            href:"",
            clickHandler:this.createChargeToggle,
            name: "Add New",
            svgIcon: "AddPlus",
            attributes:{
              className:"btn primary_bg mr-2"
            },
            type:"addnew",
            icon:"",
          }]
      }

      // console.log(this.state.tableRecords.pagination.totalRecords);

    return(
      <Wrp>
      	<BreadCrumbs breadCrumbsList={breadCrumbs} />
        <div className="viewport" style={{"background": "transparent"}}>
          <div className="view view--hor-scroll filters-v3 view-xl">
            <div className="view view--hor-scroll ember-view entity-list-view">
            	  
            	<TableRecord 
                  tableRecords={this.state.tableRecords} 
                  recordsChangeHandler={this.chargeList}
                />
            	<CreateNew
            		modelOpen = {this.state.createChargeModel}
            		toggleModel={this.createChargeToggle}
            		curState = {this.state}
            		createChargeChangeHandler={this.createChargeChangeHandler}
            		saveChargeDetails={this.saveChargeDetails}
            	/>
            	 
            </div>
          </div>
        </div>
      </Wrp>
    )
	}
}

const mapStateToProps = state => {
  return {
    authenticated: state,
    selectedWindowData:state.reducer.selectedWindowData,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChargeDetailsContainer));